"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var PODCAST_FEED_ERROR_CODES = [
    types_1.PodcastFeedErrorCode.FEED_FETCHING_FAILED,
    types_1.PodcastFeedErrorCode.FEED_FORMAT_NOT_VALID,
    types_1.PodcastFeedErrorCode.EPISODE_NOT_FOUND,
];
function transformError(error) {
    var mainError = error.response.errors && error.response.errors[0];
    if (mainError && PODCAST_FEED_ERROR_CODES.indexOf(mainError.message) !== -1) {
        error.errorCode = mainError.message;
    }
    return error;
}
exports.default = transformError;
//# sourceMappingURL=transformError.js.map